import React from 'react';

import { useSelector } from 'react-redux';
import t from 'react-translate';

// schemas
import { RootState } from 'redux/schemas';
import { useAppDispatch } from 'redux/store';

import { ActivityType } from 'redux/schemas/models/activity';
import { ComponentKeyPluralized } from 'redux/schemas/models/lecture-component';

// actions
import { setActivityExpandedInAutomatedCommunications } from 'redux/actions/course-communications';

// selectors
import { getInPersonEvent, hasInPersonEventGotCommunicationError } from 'redux/selectors/timeline';
import { isActivityExpandedInAutomatedCommunications } from 'redux/selectors/course-communications';

// components
import NvIcon from 'shared/components/nv-icon';
import NvStackedTab from 'shared/components/nv-stacked-tab';

import CommunicationCreateNewDropdown from 'communications/course_communications/components/communication-create-new-dropdown';
import CommunicationItem from 'communications/course_communications/components/communication-item/communication-item';

type InPersonEventLectureComponentProps = {
  inPersonEventId: number
};

const InPersonEventLectureComponent = ({ inPersonEventId }: InPersonEventLectureComponentProps) => {
  const dispatch = useAppDispatch();
  const inPersonEvent = useSelector((state: RootState) => getInPersonEvent(state, inPersonEventId));
  const hasCommunicationError = useSelector((state: RootState) => hasInPersonEventGotCommunicationError(state, inPersonEventId));
  const isExpanded = useSelector((state: RootState) => isActivityExpandedInAutomatedCommunications(state, ComponentKeyPluralized.IN_PERSON_EVENT, inPersonEventId));

  return (
    <React.Fragment>
      <div className={`lecture-component-row ${isExpanded && inPersonEvent?.communicationsCount > 0 && 'expanded-box'}`}>
        <NvIcon icon='work' size='smallest' />
        <div className='description'>{inPersonEvent?.title}</div>
        <div className=''>
          <CommunicationCreateNewDropdown
            activityType={ActivityType.IN_PERSON_EVENT}
            activityId={inPersonEventId}
          />
        </div>
        {inPersonEvent?.communicationsCount > 0 && (
          <NvStackedTab
            count={inPersonEvent.communicationsCount}
            hasError={hasCommunicationError}
            isExpanded={isExpanded}
            errorMessage={t.COURSE_COMMUNICATIONS.WARNINGS.ACTIVITY_COMMUNICATION()}
            onClick={() => dispatch(setActivityExpandedInAutomatedCommunications({
              type: ComponentKeyPluralized.IN_PERSON_EVENT,
              id: inPersonEventId,
              isExpanded: !isExpanded,
            }))}
          />
        )}
      </div>
      {
        // Communications
        isExpanded
          && inPersonEvent?.communications
          && inPersonEvent.communications.map(communicationId => (
          <CommunicationItem
            key={communicationId.toString()}
            communicationId={communicationId}
          />
        ))
      }
    </React.Fragment>
  );
};

export default InPersonEventLectureComponent;
